import { render, staticRenderFns } from "./vcAttachment.vue?vue&type=template&id=3aa9f9ae&scoped=true&lang=pug&"
import script from "./vcAttachment.vue?vue&type=script&lang=js&"
export * from "./vcAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa9f9ae",
  null
  
)

export default component.exports